// 规则匹配条件的草稿与摘要；路由只按 MCC/MNC/发送方匹配，没有时间条件（D132）。优先级与目标由各自表单维护。
import { rowKey } from "@/app/form";
import type { RouteConditions } from "@/app/routing";

export interface ItemDraft {
  /** 只在前端用的稳定标识，做列表 key。不提交。 */
  key: number;
  mcc: string; mnc: string;
  /** sender 条件默认不展示，点"添加"后才出现；关掉即不带这个条件。 */
  senders_on: boolean; senders: string;
  /** 发送目标的键：g 加通道组 id，或 c 加通道 id；空表示还没选。 */
  target: string;
}
/** 初始化独立规则的条件控件，不生成路由或绑定身份。 */
export function itemDraft(): ItemDraft {
  return { key: rowKey(), mcc: "", mnc: "", senders_on: false, senders: "", target: "" };
}

/** 规则匹配条件摘要，列表页与编辑页用。 */
export function conditionSummary(it: RouteConditions): string {
  const parts: string[] = [];
  if (it.mcc) parts.push(`${it.mcc}-${it.mnc || "*"}`);
  if (it.senders?.length) parts.push(`sender ${it.senders.join(",")}`);
  return parts.length ? parts.join("；") : "不限";
}
